import { Button, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const VOMBanner = ({ count }) => {
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email
  );
  const navigate = useNavigate();

  return (
    <Col md={12} className="px-3 py-4" style={{ borderColor: "navy" }}>
      <div
        className="d-flex align-items-center justify-content-between p-4 rounded"
        style={{
          backgroundColor: "#fffeed",
          border: "1px solid #fecaca",
          minHeight: "80px",
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center me-3"
            style={{
              backgroundColor: "#ffe9ce",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              color: "#ff6347",
            }}
          >
            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2v-2zm0-6h2v4h-2v-4z" />
            </svg>
          </div>
          <div>
            <div className="fw-bold text-dark fs-5 mb-1">
              {count} VOM Request(s) Awaiting Your Signature
            </div>
            <div className="text-muted">
              Please review and complete the pending verification request(s).
            </div>
          </div>
        </div>
        <div>
          <Button
            variant="danger"
            className="d-flex align-items-center bg-info"
            style={{
              backgroundColor: "#dc2626",
              borderColor: "#dc2626",
              fontWeight: "500",
              padding: "10px 20px",
            }}
            onClick={() => {
              navigate("/voms/borrower");
            }}
          >
            Review Pending VOM
            <svg
              className="ms-2"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
            </svg>
          </Button>
        </div>
      </div>
    </Col>
  );
};

export default VOMBanner;
